module.exports = __webpack_public_path__ + "static/media/wDark_cloudy_rainy.9202b3dd.svg";